/* eslint-disable prettier/prettier */
import type { LearnerUpload } from '../components/pageComponents/ViewLearnerUploads';
import type { CourseSubmission } from '../services/courseAssessmentSubmission.service';

/**
 * Flattens course submissions into one "View Learner Uploads" row per file.
 * Shared by the coach (ProgramDetailsPage) and admin (AdminEditProgramPage) screens.
 */
export const mapSubmissionsToLearnerUploads = (
	submissions?: CourseSubmission[] | null
): LearnerUpload[] => {
	if (!submissions?.length) {
		return [];
	}

	return submissions.flatMap(submission =>
		(submission.files || []).map(file => ({
			// UI row ID can remain file ID
			id: file.fileid,

			// Used for download
			fileId: file.fileid,

			// Review API needs assessmentsubmissions.id
			submissionId: submission.id,

			uploadedBy: submission.student_name,
			assignmentName: submission.assessment_title,

			fileType:
				file.filename?.split('.').pop()?.toUpperCase() ||
				file.mimetype ||
				'File',

			fileName: file.filename ?? null,
			uploadedAt: file.uploadedat ?? submission.submittedat ?? null,

			// null = not reviewed yet, true = passed, false = failed
			isApproved: submission.passed ?? null,
		}))
	);
};
